module.exports = __webpack_public_path__ + "static/media/sn_ab_ldbrd2.0c7f15d1.jpg";